import styled from "styled-components";

export const Wrapper = styled.div`
  .ant-segmented-thumb-motion {
    opacity: 0;
  }
  .ant-segmented {
    background: #333336;
    color: white;
    border-radius: 2px;
    height: 32px;
    display: flex;
    width: max-content;
    align-items: center;
    padding: 4px 3px;
  }
  .ant-segmented-item {
    font-size: 12px;
    height: 24px;
    .ant-segmented-item-label {
      min-height: 24px;
      line-height: 24px;
    }
    &.ant-segmented-item-selected {
      background: #414144;
      border-radius: 2px;
      color: var(--main-color);
    }
  }
`;

export const GapLine = styled.div<{ showGapLine?: boolean }>`
  ${({ showGapLine }) =>
    showGapLine && `border-top: 1px solid rgba(255, 255, 255, 0.1);`}
  margin: 16px 0;
`;
